module.exports = __webpack_public_path__ + "img/mtt_2.1.650ec411.png";